import { Injectable } from '@angular/core';
import { DataBagService } from '../../common/data-bag.service';
import { FooterItem } from './footer.model';

@Injectable({
	providedIn: 'root',
})
export class FooterService {
	constructor(private readonly bag: DataBagService) {}
	createFooterItems(footerItems: FooterItem[]) {
		this.bag.post('/www/footer_item/', footerItems, (result, error) => {
			if (error) throw new Error(JSON.stringify(error.error));
			footerItems.forEach((value, i) => {
				value.isNew = false;
				value.id = result[i].id;
			});
		});
	}

	updateFooterItems(footerItems: FooterItem[]) {
		this.bag.put('/www/footer_item/bulk_update/', footerItems, (result, error) => {
			if (error) throw new Error(JSON.stringify(error.error));
		});
	}
}
